import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ShippingCountryBaseFragmentDoc } from '../../fragments/__generated__/ShippingCountry.generated';
import { ShippingBaseFragmentDoc } from '../../fragments/__generated__/Shipping.generated';
import { CurrencyExchangeRateFragmentDoc } from '../../fragments/__generated__/CurrencyExchangeRate.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ShippingMethodCountriesQueryVariables = Types.Exact<{
  countryCode: Types.CountryCodeEnum;
}>;


export type ShippingMethodCountriesQuery = { shippingMethodCountries: { edges: Array<{ node: { id: string, pk: number, shippingTime: string, shippingMethod: { id: string, pk: number, name: string, isPhoneRequired: boolean, active: boolean } } }> } };

export type CurrentCurrencyExchangeRateQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentCurrencyExchangeRateQuery = { currentCurrencyExchangeRate: { id: string, pk: number, currencyCode: string, rate: number } | null };


export const ShippingMethodCountriesDocument = gql`
    query ShippingMethodCountries($countryCode: CountryCodeEnum!) {
  shippingMethodCountries(
    first: 20
    filters: {countryCode: $countryCode, shippingMethod: {active: true}}
  ) {
    edges {
      node {
        ...ShippingCountryBaseFragment
        shippingMethod {
          ...ShippingBaseFragment
        }
      }
    }
  }
}
    ${ShippingCountryBaseFragmentDoc}
${ShippingBaseFragmentDoc}`;

/**
 * __useShippingMethodCountriesQuery__
 *
 * To run a query within a React component, call `useShippingMethodCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingMethodCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingMethodCountriesQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useShippingMethodCountriesQuery(baseOptions: Apollo.QueryHookOptions<ShippingMethodCountriesQuery, ShippingMethodCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingMethodCountriesQuery, ShippingMethodCountriesQueryVariables>(ShippingMethodCountriesDocument, options);
      }
export function useShippingMethodCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingMethodCountriesQuery, ShippingMethodCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingMethodCountriesQuery, ShippingMethodCountriesQueryVariables>(ShippingMethodCountriesDocument, options);
        }
export type ShippingMethodCountriesQueryHookResult = ReturnType<typeof useShippingMethodCountriesQuery>;
export type ShippingMethodCountriesLazyQueryHookResult = ReturnType<typeof useShippingMethodCountriesLazyQuery>;
export type ShippingMethodCountriesQueryResult = Apollo.QueryResult<ShippingMethodCountriesQuery, ShippingMethodCountriesQueryVariables>;
export function refetchShippingMethodCountriesQuery(variables: ShippingMethodCountriesQueryVariables) {
      return { query: ShippingMethodCountriesDocument, variables: variables }
    }
export const CurrentCurrencyExchangeRateDocument = gql`
    query CurrentCurrencyExchangeRate {
  currentCurrencyExchangeRate {
    ...CurrencyExchangeRateFragment
  }
}
    ${CurrencyExchangeRateFragmentDoc}`;

/**
 * __useCurrentCurrencyExchangeRateQuery__
 *
 * To run a query within a React component, call `useCurrentCurrencyExchangeRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentCurrencyExchangeRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentCurrencyExchangeRateQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentCurrencyExchangeRateQuery(baseOptions?: Apollo.QueryHookOptions<CurrentCurrencyExchangeRateQuery, CurrentCurrencyExchangeRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentCurrencyExchangeRateQuery, CurrentCurrencyExchangeRateQueryVariables>(CurrentCurrencyExchangeRateDocument, options);
      }
export function useCurrentCurrencyExchangeRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentCurrencyExchangeRateQuery, CurrentCurrencyExchangeRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentCurrencyExchangeRateQuery, CurrentCurrencyExchangeRateQueryVariables>(CurrentCurrencyExchangeRateDocument, options);
        }
export type CurrentCurrencyExchangeRateQueryHookResult = ReturnType<typeof useCurrentCurrencyExchangeRateQuery>;
export type CurrentCurrencyExchangeRateLazyQueryHookResult = ReturnType<typeof useCurrentCurrencyExchangeRateLazyQuery>;
export type CurrentCurrencyExchangeRateQueryResult = Apollo.QueryResult<CurrentCurrencyExchangeRateQuery, CurrentCurrencyExchangeRateQueryVariables>;
export function refetchCurrentCurrencyExchangeRateQuery(variables?: CurrentCurrencyExchangeRateQueryVariables) {
      return { query: CurrentCurrencyExchangeRateDocument, variables: variables }
    }